<template>
  <tr>
    <td>
      <input
        type="text"
        v-model="formData.no_bl"
        @keydown.enter="focusRefs('bl')"
        @blur="updateContainer"
        ref="no_bl"
      />
    </td>
    <td>
      <p>{{ formData.cargo }}</p>
    </td>
    <td>
      <p>{{ formData.no_container }}</p>
    </td>
    <td>
      <input
        type="text"
        v-model="formData.bl"
        @keydown.enter="updateContainer"
        @blur="updateContainer"
        ref="bl"
      />
    </td>
  </tr>
</template>

<script>
import axios from "axios";

export default {
  name: "Container",
  props: ["data"],
  data() {
    return {
      formData: {
        no_container: "",
        cargo: "",
        bl: "",
        no_bl: ""
      }
    };
  },
  methods: {
    async updateContainer() {
      const cargo = (this.formData.cargo || "").trim();
      const noContainer = (this.formData.no_container || "").trim();

      if (!cargo && !noContainer) {
        return;
      }

      await axios
        .put(`update-container-data-bl/${this.data.id}`, this.formData)
        .then(res => {
          // this.$emit('fetch-bl');
        })
        .catch(err => {
          alert(err.response.data.message);
        });
    },
    focusRefs(id) {
      this.$refs[id].focus();
    }
  },
  created() {
    this.formData.no_container = this.data.no_container;
    this.formData.cargo = this.data.cargo;
    this.formData.bl = this.data.bl;
    this.formData.no_bl = this.data.no_bl;
  }
};
</script>

<style scoped>
input[type="text"],
input[type="date"] {
  outline: none;
  border: 1px solid lightgray;
  padding: 0 0.5em;
  width: 100%;
}
</style>

<style lang="scss" scoped>
tbody {
  tr:hover {
    background-color: transparent !important;
  }
}
</style>
